import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { useLocation } from "react-router-dom";

import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Card,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  Rating,
  Step,
  StepButton,
  StepConnector,
  Stepper,
  StepLabel,
  TextField,
} from "@mui/material";

import StudentGrading from "./StudentGrading";

import StarIcon from '@mui/icons-material/Star';
import tableIcons from "../tableFormatting/tableIcons";
import ratingLabels from "./ratingLabels.js";

import "./styles.css";


const AssignmentsForm = ({ name }) => {

    const location = useLocation();
    const pageData = location.state;
    const auth = useSelector(state => state.firebase);

    const [ratingValue, setRatingValue] = useState(5);
    const [ratingHover, setRatingHover] = useState(-1);

    const [assignments, setAssignments] = useState(pageData.assignments);

    const [givenAnswer, setGivenAnswer] = useState("");
    const [parentVisibility, setParentVisibility] = useState(true);
    const [materialVisibility, setMaterialVisibility] = useState(false);
    const [childVisibility, setChildVisibility] = useState(false);
    const [subVisibility, setSubVisibility] = useState(false);

    const [completionStatus, setCompletionStatus] = useState(false);

  const [quizQuestions, setQuizQuestions] = useState(pageData.assignments[0].quiz);
  const [essayQuestions, setEssayQuestions] = useState(pageData.assignments[0].essay);
  const [ratingQuestions, setRatingQuestions] = useState(pageData.assignments[0].ratings);
  const [quizNodeAnswers, setQuizNodeAnswers] = useState([]);
  const [essayNodeAnswers, setEssayNodeAnswers] = useState([]);
  const [answerType, setAnswerType] = useState(assignments[0].quiz[0]);

    useEffect(() => {
        setGivenAnswer(name);
    }, [name])

    const [steps, setSteps] = useState([]);

    useEffect(() => {
      const stepsArr = [];
      pageData.data.map((d, i) => {
        stepsArr.push(i)
      })

      setSteps(stepsArr)



    },[])
    const [activeStep, setActiveStep] = useState(0);
    const [activeMaterialStep, setActiveMaterialStep] = useState(0);
    const [activeAdditionalMaterialStep, setActiveAdditionalMaterialStep] = useState(0);
    const [activeQuizStep, setActiveQuizStep] = useState(0);
    const [activeEssayStep, setActiveEssayStep] = useState(0);
    const [activeRatingStep, setActiveRatingStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [completed2, setCompleted2] = useState([]);


  useEffect(() => {
    if(name !== "" && selectedDataSet == 1) {
      
          setQuizNodeAnswers([...quizNodeAnswers, {index: quizNodeAnswers.length, name: name}])
    } 
    if(name !== "" && selectedDataSet == 2) {
      
          setEssayNodeAnswers([...essayNodeAnswers, {index: essayNodeAnswers.length, name: name}])
    } 


   
  }, [name])
  const totalSteps = () => {
    return steps.length;
  };


  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeMaterialStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
        if(activeMaterialStep < 1) {

          setActiveMaterialStep(activeMaterialStep + 1);

        } else {

          setActiveMaterialStep(0)
        }
  };

// console.log(allStepsCompleted)
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setQuizQuestions(assignments[step].quiz);
    setEssayQuestions(assignments[step].essay);
    setRatingQuestions(assignments[step].ratings);
    setActiveQuizStep(0);
    setActiveEssayStep(0);
    setActiveRatingStep(0);
    // setAnswerType(assignments[step].quiz[activeQuizStep].answerType)
    setAnswerType(1)
    setActiveStep(step);
  };
// console.log(quizQuestions)



  const handleComplete = () => {
  
    const newCompleted = completed;
    newCompleted[activeMaterialStep] = true;
    setCompleted(newCompleted);

    handleNext();

    const verify = []
    pageData.data.map((d, i) => {
      if(completed[i] == true) {
        verify.push(i)
      }
    })
    // console.log(verify.length)
    if(verify.length == steps.length) {
      setCompletionStatus(true)
    }

  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

// console.log(assignments[activeStep].quiz[activeQuizStep].answerType)
  const handleQuizStep = (step) => () => {
  // console.log(assignments[activeStep].quiz[activeQuizStep])
setQuizNodeAnswers(assignments[activeStep].quiz[step].answerOptions)
  setAnswerType(assignments[activeStep].quiz[step].answerType)

       setActiveQuizStep(step);

      //  setActiveAnswerType(assignments[activeStep].quiz[activeQuizStep].answerType)
 
  };


  const handleEssayStep = (step) => () => {

    // setEssayQuestions(assignments[activeStep].essay[step].questionText)
    // setEssayQuestions(assignments[activeStep].essay[step].questionText)
       setActiveEssayStep(step);

      //  setActiveAnswerType(assignments[activeStep].quiz[activeQuizStep].answerType)
 
  };
  const handleRatingStep = (step) => () => {

    // setEssayQuestions(assignments[activeStep].essay[step].questionText)
    // setEssayQuestions(assignments[activeStep].essay[step].questionText)
       setActiveRatingStep(step);

      //  setActiveAnswerType(assignments[activeStep].quiz[activeQuizStep].answerType)
 
  };


  useEffect(() => {
    if(selectedDataSet == 1) {
      const seen = new Set();
      const filteredArr = quizNodeAnswers.filter(el => {
        const duplicate = seen.has(el.name);
        seen.add(el.name);
        return !duplicate;
      });
      // console.log(filteredArr)
      setQuizNodeAnswers(filteredArr)
      // console.log(quizNodeAnswers)
    }
    if(selectedDataSet == 2) {
      const seen = new Set();
      const filteredArr = essayNodeAnswers.filter(el => {
        const duplicate = seen.has(el.name);
        seen.add(el.name);
        return !duplicate;
      });
      // console.log(filteredArr)
      setEssayNodeAnswers(filteredArr)
      // console.log(quizNodeAnswers)
    }

  }, [givenAnswer]);
 

  const handleChipDelete = (index) => {
    const updatedItems = quizNodeAnswers && quizNodeAnswers.filter((element , i) => i !== index);
    setQuizNodeAnswers(updatedItems);
    setAssignments(assignments)
  }

  const handleEssayChipDelete = (index) => {
    const updatedItems = essayNodeAnswers && essayNodeAnswers.filter((element , i) => i !== index);
    setEssayNodeAnswers(updatedItems);
    setAssignments(assignments)
  }


  function getLabelText(ratingValue) {
    return `${ratingValue} Star${ratingValue !== 1 ? 's' : ''}, ${ratingLabels[ratingValue]}`;
  }
    
    const [submissionData, setSubmissionData] = useState([]);
    const [selectedDataSet, setSelectedDataSet] = useState(0);


    const [picture, setPicture] = useState(null);
    const [imgData, setImgData] = useState(null);
    const onChangePicture = e => {
      if (e.target.files[0]) {
        console.log("picture: ", e.target.files);
        setPicture(e.target.files[0]);
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImgData(reader.result);
          console.log(picture)
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    };

    const [assignmentBody, setAssignmentBody] = useState("")
    const [assignmentRef, setAssignmentRef] = useState("")

    useEffect(() => {
      setQuizQuestions(assignments[activeStep].quiz);
      setEssayQuestions(assignments[activeStep].essay);
      setRatingQuestions(assignments[activeStep].ratings);
    },[selectedDataSet])


    const handleMaterialStep = (step) => () => {

         setActiveMaterialStep(step);

    
    };
    const handleAdditionalMaterialStep = (step) => () => {

         setActiveAdditionalMaterialStep(step);

    
    };

const toggleMaterial = () => {
  setMaterialVisibility(!materialVisibility)
}
const toggleParent = () => {
  setParentVisibility(!parentVisibility)
}
const toggleChild = () => {
  setChildVisibility(!childVisibility)
}
const toggleSub = () => {
  setSubVisibility(!subVisibility)
}


const handleGrading = () => {
  setSelectedDataSet(4);
}
    
    const handleSubmit = () => {
        // setOpen(false);
        setSubmissionData({

        })
    }
// console.log(completionStatus)

return (
 <>
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ marginBottom: "30px" }}
    >

      <p>Assignments:</p>

        <div style={{ margin: "20px 0 20px 0", textAlign: "center" }}>

        <Stepper nonLinear activeStep={activeStep} >
          {assignments.map((label, index) => (
            <Step key={index}>
              <StepButton color="inherit" onClick={handleStep(index)} />
            </Step>
          ))}
        </Stepper>
        </div>    

          <ButtonGroup disableElevation  style={{ margin: "20px 0 20px 0" }}>
          {pageData.assignments[activeStep].quiz.length > 0 ? (
            <Button color={completionStatus == true ? "success" : "primary"} variant={selectedDataSet === 0 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(0)}>Materials</Button>
            ) : (
              <></>
            )}
              {pageData.assignments[activeStep].quiz.length > 0 ? (
                <Button variant={selectedDataSet === 1 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(1)}>Quiz</Button>
                ) : (
                  <></>
                )}

              {pageData.assignments[activeStep].essay.length > 0 ? (
                <Button variant={selectedDataSet === 2 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(2)}>Essay</Button>
                ) : (
                  <></>
                )}

              {pageData.assignments[activeStep].ratings.length > 0 ? (
                <Button variant={selectedDataSet === 3 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(3)}>Feedback</Button>
              ) : (
                <></>
              )}

          </ButtonGroup>
    </Grid>      
             

        


          {selectedDataSet == 0 ? (
            <>
            <Stepper nonLinear activeStep={activeMaterialStep}>
              {pageData.data.map((label, index) => (
    
          
                  <Step key={index} completed={completed[index]}>

                    <StepButton color="inherit" onClick={handleMaterialStep(index)}>
                      <StepLabel>{label.name}</StepLabel>
                    
                    </StepButton>

                  </Step>
          
              ))}              
          
          </Stepper>
          
            {pageData.data.map((d, i) => (
              <>
            {activeMaterialStep == i && (
              <>
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                  style={{ marginBottom: "30px", maxWidth: "80vw" }}
                >
                  <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
                    <Button onClick={toggleParent}>Parent Node</Button>
                    {parentVisibility == true && (

                   
                    <Card sx={{ minWidth: "80vw", margin: "20px 0 20px 0" }}>

        
                  

                <h1>{d.name}</h1>
              <p>{d.description}</p>
              <Button onClick={toggleMaterial}>Additional Materials</Button>
              {materialVisibility == true && (
                <>
                <Stepper nonLinear activeStep={activeAdditionalMaterialStep} style={{ margin: "40px 0 40px 0" }}>
              {pageData.data[activeMaterialStep].additionalMaterial.video != "" ? (
    
          
                  <Step key={0}>

                    <StepButton color="inherit" onClick={handleAdditionalMaterialStep(0)}>
                      <StepLabel>Video</StepLabel>
                    
                    </StepButton>

                  </Step>
          
              ) : (
                <></>
              )}              
              {pageData.data[activeMaterialStep].additionalMaterial.link != "" ? (
    
          
                  <Step key={1}>

                    <StepButton color="inherit" onClick={handleAdditionalMaterialStep(1)}>
                      <StepLabel>Link</StepLabel>
                    
                    </StepButton>

                  </Step>
          
          ) : (
            <></>
          )}                  
              {pageData.data[activeMaterialStep].additionalMaterial.photo != null ? (
    
          
                  <Step key={2}>

                    <StepButton color="inherit" onClick={handleAdditionalMaterialStep(2)}>
                      <StepLabel>Photo</StepLabel>
                    
                    </StepButton>

                  </Step>
          
          ) : (
            <></>
          )}                   
          
          </Stepper>
            {activeAdditionalMaterialStep == 0 ? (
              <>
              {d.additionalMaterial.video != null && d.additionalMaterial.video != "" && (
        
                <>
                <p>Additional Video Content:</p>
                <iframe width="560" height="315" src={d.additionalMaterial.video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </>
              )}  
              </>
            ) : activeAdditionalMaterialStep == 1 ? (
              <>
              {d.additionalMaterial.link != null && d.additionalMaterial.link != "" && (
                <div
                  alignItems="center"
                  justifyContent="center"
                  style={{ margin: "20px 0 20px 0" }}
                >
                  <p style={{ margin: "20px 0 40px 0" }}>Additional Reading Materials:</p>
                <Avatar
                    style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
                    src={"https://" + new URL(d.additionalMaterial.link).host + "/favicon.ico"}
                  />
                  {/* <img src={"https://" + linkSplit + "/favicon.ico/"} ></img> */}
                  {/* <p>{new URL(descriptionData[i].additionalMaterial.link).host}</p>
                   */}
                   <Button style={{ margin: "20px 0 20px 0" }} onClick={() => {window.open(d.additionalMaterial.link, "_blank")}}>{new URL(d.additionalMaterial.link).host}</Button>
                  </div>
              )}  
              </>
            ) : activeAdditionalMaterialStep == 2 ? (
              <>
              {d.additionalMaterial.photo != null && d.additionalMaterial.photo != "" && (
                <div>
                  <p>Additional Image Content:</p>
                  <img src={d.additionalMaterial.photo} />
                </div>
              )}  
              </>
            ) : (
              <></>
            )}
            </>
              )}
              
           
            
           
              <div style={{ margin: "0 0 40px" }} />

              </Card>

)}
               <Button onClick={toggleChild}>Child Nodes</Button>
             <Button onClick={toggleSub}>Sub Nodes</Button>


              {d.children.map((x, y) => (
              <>
               <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
               {childVisibility == true && (
                <Card sx={{ minWidth: "80vw", margin: "20px 0 20px 0" }}>

                  <h1>{x.name}</h1>
                  <p>{x.description}</p>
                </Card>
               )}
                    
             </div>
          

          {x.children.map((a, b) => (
          
          <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
             {subVisibility == true && (
          <Card sx={{ minWidth: "80vw", margin: "20px 0 20px 0" }}>

            <h1>{a.name}</h1>
          <p>{a.description}</p>
          </Card>
             )}
            </div>

              ))}
              </>
        ))}






              </div>
              </Grid>
              
             
            </>
            )}
           
          
             </>






            ))}
            {completed[activeMaterialStep] != true ? (
              <Button
              onClick={() => handleComplete()}
              variant="contained"
              component="label"
              style={{ float: "right" }}
            >
              Completed {pageData.data[activeMaterialStep].name}
            </Button>
            ) : (
              <>
              <Button
              
              color="success"
              variant="contained"
              component="label"
              style={{ float: "right" }}
            >
              Tasks Complete!
            </Button>
            </>
            )}
        
             
            </>

































          ) : selectedDataSet == 1 ? (
    <>
<p>Question:</p>
    
    <div style={{ padding: "0 0 20px 0", textAlign: "center" }}>

<Stepper style={{ margin: "20px 0 20px" }} nonLinear activeStep={activeQuizStep} connector={<StepConnector />}>

        {quizQuestions.map((d, i) => (
          <Step key={i} >

            <StepButton color="inherit" onClick={handleQuizStep(i)}>
              {/* {label} */}
            </StepButton>

          </Step>
        ))}
      
            
      </Stepper>
              </div>    

              {quizQuestions.map((d, i) => (
               
               <>
 
       {activeQuizStep == i && (

       <>

       {/* <TextField multiline={true} id="outlined-basic" defaultValue={d.questionText} label={"Question " + (i + 1)} style={{ minWidth: "80%", padding: "0 0 0px 0" }} onChange={(e) => { setEditedQuizQuestion(e.target.value) }} /> */}
       <TextField 
         multiline={true} 
         id="outlined-basic" 
         value={d.questionText} 
         label={"Question " + (i + 1)} 
         style={{ minWidth: "80%", padding: "0 0 0px 0" }} 
         InputProps={{
          readOnly: true,
        }}
        //  onChange={(e) => { handleQuizQuestion(e.target.value) }} 
        //  InputProps={{
        //    endAdornment: <InputAdornment position="end">
        //      <IconButton 
        //     //  onClick={() => { setUpdateValues(true) }}
        //      >
        //      <tableIcons.Check>
        //    </tableIcons.Check>
        //    </IconButton>
        //  </InputAdornment> 
        //    }}
         />


       <FormControl style={{ margin: "40px 0 40px" }}></FormControl>

       {answerType == 0 ? (
              <>

                <TextField multiline={true} id="outlined-basic" 
                
                InputProps={{
                  onKeyDown: (event) => {
                    event.preventDefault();
                 },
                  startAdornment: quizNodeAnswers.map((d, index) => (
                    <Chip
                      key={index}
                      
                      // tabIndex={-1}
                      label={d.name}
                      color="info"
                      // variant="outlined"
                      // onDelete={handleChipDelete(index)}
                      onDelete={() => handleChipDelete(index)}
                      // className={classes.chip}
                      // onDelete={handleChipDelete(d)}
                    />
                  )),
                  endAdornment: <InputAdornment position="end">
                  <IconButton 
                  // onClick={() => { setUpdateValues(true) }}
                  >
                  <tableIcons.Check>
                </tableIcons.Check>
                </IconButton>
              </InputAdornment> 
                }}
                // label={"Answer " + (i + 1)} style={{ minWidth: "80%", padding: "0 0 40px 0" }} onChange={(e) => { handleQuizNodes(e.target.value)}}>
                label={"Answer " + (i + 1)} style={{ minWidth: "80%", padding: "0 0 40px 0" }}>
                </TextField>
            {/* //  )} */}
         
</>
            ) : answerType == 1 ? (
                <TextField 
                multiline={true} 
                id="outlined-basic" 
                label={"Answer " + (i + 1)} 
                // defaultValue={assignments[activeStep].quiz[activeQuizStep].answerText} 
                defaultValue=""
                style={{ minWidth: "80%", padding: "0 0 40px 0" }} 
                // onChange={(e) => { setQuizAnswer(e.target.value) }}
                InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton 
                  // onClick={() => { setUpdateValues(true) }}
                  >
                  <tableIcons.Check>
                </tableIcons.Check>
                </IconButton>
              </InputAdornment> 
                }}
                />

            ) : answerType == 2 ? (
              <div style={{ textAlign: "center", margin: "0 0 30px 0" }}>
              {/* {questions[currentQuestion].answerOptions.map((answerOption) => (
                <Button onClick={() => handleAnswerOptionClick(answerOption.isCorrect)}>{answerOption.answerText}</Button>
              ))} */}
                              <Rating
                                name="hover-feedback"
                                value={ratingValue}
                                precision={1}
                                getLabelText={getLabelText}
                                onChange={(event, newValue) => {
                                  setRatingValue(newValue);
                                }}
                                max={10}
                                onChangeActive={(event, newHover) => {
                                  setRatingHover(newHover);
                                }}
                                emptyIcon={<StarIcon style={{ opacity: 0.55, marginBottom: "22px" }} fontSize="inherit" />}
                              />
                              {ratingValue !== null && (
                                <Box sx={{ ml: 2 }}>{ratingLabels[ratingHover !== -1 ? ratingHover : ratingValue]}</Box>
                              )}
                          
            </div>
            ) : (
              <>
              {setAnswerType(0)}
              </>
              )}
          
            </>

  
            )}
            </>
          ))}



















   

    </>
) : selectedDataSet == 2 ? (
    <>
  <p>Topic:</p>
  <div style={{ padding: "0 0 20px 0", textAlign: "center" }}>


<Stepper style={{ margin: "20px 0 20px" }} nonLinear activeStep={activeEssayStep} connector={<StepConnector />}>

        {essayQuestions.map((d, i) => (
          <Step key={i} >

            <StepButton color="inherit" onClick={handleEssayStep(i)}>
              {/* {label} */}
            </StepButton>

          </Step>
        ))}
      
            
      </Stepper>
              </div>    

              {essayQuestions.map((d, i) => (
             
               <>

       {activeEssayStep == i && (
<>
    
<TextField 
         multiline={true} 
         id="outlined-basic" 
         value={d.questionText} 
         label={"Question " + (i + 1)} 
         style={{ minWidth: "80%", padding: "0 0 0px 0" }} 
         InputProps={{
          readOnly: true,
        }}
        //  onChange={(e) => { handleQuizQuestion(e.target.value) }} 
        //  InputProps={{
        //    endAdornment: <InputAdornment position="end">
        //      <IconButton 
        //     //  onClick={() => { setUpdateValues(true) }}
        //      >
        //      <tableIcons.Check>
        //    </tableIcons.Check>
        //    </IconButton>
        //  </InputAdornment> 
        //    }}
         />

        <Button

    component="label"
    style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}
    >
    Upload Image
    <input
        type="file"
        className="playerProfilePic_home_title"
        onChange={onChangePicture}
        hidden
    />
    </Button>

    <div>
        <img style={{ maxWidth: "40vw", padding: "10px 0 30px 0", display: "block", marginLeft: "auto", marginRight: "auto" }} src={imgData} />
    </div>
            <Grid 
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ marginBottom: "30px" }}
            >
         
            <TextField 
              // fullWidth 
              id="outlined-basic" 
              // id="fullWidth" 
              multiline={true} 
              minRows="6" 
              label={"Answer " + (i + 1)} 
              style={{ minWidth: "80%", padding: "0 0 40px 0" }}
              onChange={(e) => { setAssignmentBody(e.target.value) }} 
              InputProps={{
                startAdornment: essayNodeAnswers.map((d, index) => (
                  <Chip
                    key={index}
                    // tabIndex={-1}
                    label={d.name}
                    color="info"
                    // variant="outlined"
                    // onDelete={handleChipDelete(index)}
                    onDelete={() => handleEssayChipDelete(index)}
                    // className={classes.chip}
                    // onDelete={handleChipDelete(d)}
                  />
                )),
                endAdornment: <InputAdornment position="end">
                <IconButton 
                // onClick={() => { setUpdateValues(true) }}
                >
                <tableIcons.Check>
              </tableIcons.Check>
              </IconButton>
            </InputAdornment> 
              }}
  
              >
              </TextField>
        
            <div style={{ margin: "10px" }} />
            <TextField label="Reference links" id="outlined-basic"  style={{ minWidth: "80%" }} multiline={true} minRows="2" onChange={(e) => { setAssignmentRef(e.target.value) }} />
    </Grid>
    </>
      )}
      </>
    ))}

    </>

) : selectedDataSet == 3 ? (

  <>
<p>Ratings:</p>
<div style={{ padding: "0px 0 20px 0", textAlign: "center" }}>


<Stepper style={{ margin: "20px 0 20px" }} nonLinear activeStep={activeRatingStep} connector={<StepConnector />}>

        {ratingQuestions.map((d, i) => (
          <Step key={i} >

            <StepButton color="inherit" onClick={handleRatingStep(i)}>
              {/* {label} */}
            </StepButton>

          </Step>
        ))}
       
              

            
      </Stepper>
              </div>  

                              {ratingQuestions.map((d, i) => (
            <>
            {activeRatingStep == i && (
              <>




              
            <TextField 
              multiline={true} 
              id="outlined-basic" 
              value={d.questionText} 
              label={"Feedback " + (i + 1)} 
              style={{ 
                minWidth: "80%", 
                padding: "0 0 40px 0" 
              }} 
              // onChange={(e) => { setRatingQuestion(i + "," + e.target.value) }}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton 
                  // onClick={(e) => { handleRatingQuestions() }}
                  >
                  <tableIcons.Check>
                </tableIcons.Check>
                </IconButton>
              </InputAdornment> 
                }}
              />

<Rating
                                name="hover-feedback"
                                value={ratingValue}
                                precision={1}
                                getLabelText={getLabelText}
                                onChange={(event, newValue) => {
                                  setRatingValue(newValue);
                                }}
                                max={10}
                                onChangeActive={(event, newHover) => {
                                  setRatingHover(newHover);
                                }}
                                emptyIcon={<StarIcon style={{ opacity: 0.55, marginBottom: "22px" }} fontSize="inherit" />}
                              />
                              {ratingValue !== null && (
                                <Box sx={{ ml: 2 }}>{ratingLabels[ratingHover !== -1 ? ratingHover : ratingValue]}</Box>
                              )}
</>
            )}
 

 
</>

  ))}
     
    </>



) : selectedDataSet == 4 ? (

  <StudentGrading data={pageData.data} />


) : (
  <div>
    {/* Error */}
    </div>

  



)}



       {selectedDataSet == 1 ? (
      <Button
        onClick={() => setSelectedDataSet(4)}
        variant="contained"
        component="label"
        style={{ float: "right", marginTop: "20px" }}
        >
    Grading
    </Button>
       ) : selectedDataSet == 4 ? (
        <Button
        onClick={() => setSelectedDataSet(1)}
        variant="contained"
        component="label"
        style={{ float: "right", marginTop: "20px" }}
        >
    Hide
    </Button>
       ) : (
<div>
  {/* Error */}
  </div>

       )}

    </>
    //     </Box>
    // </Modal>
)
};


export default AssignmentsForm;